import React, { useState } from 'react';
import { Box, Button, Typography, backdropClasses } from '@mui/material';

import { api } from 'src/Api';
import RoleChangeDropdown from 'src/layouts/dashboard/RoleChangeDropDown';
import { t } from 'i18next';
import { LoadingButton } from '@mui/lab';

export default function ChangeRoleModal({ handleClose, user, refreshAdmin }) {
  // console.log('user', user);

  const [statusLoading, setstatusLoading] = useState(false);
  const [selectedRole, setselectedRole] = useState(null);
  function AssignRole(roleSelected, userId) {
    setstatusLoading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('user_id', userId);
    roleSelected && formdata.append('role_id', roleSelected ? roleSelected : user?.role?.id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    fetch(api.assignRole, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to get brands');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        refreshAdmin();
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setstatusLoading(false);
      });
  }
  console.log('selectedrole', selectedRole);
  return (
    <Box p={3} flexDirection={'column'} display={'flex'} flex={1}>
      <Typography py={3} align="center" variant="h5">
        Change User Role
      </Typography>
      <RoleChangeDropdown
        dontAppend={true}
        alreadyRole={user?.role}
        fullWidth={true}
        setRole={(roleSelected) => {
          setselectedRole(roleSelected);
        }}
      />
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
        <LoadingButton
          disabled={!selectedRole}
          style={{ marginTop: 20, marginRight: 10 }}
          onClick={() => {
            AssignRole(selectedRole, user?.id);
          }}
          variant="contained"
          loading={statusLoading}
        >
          Save
        </LoadingButton>
        <Button
          style={{ marginTop: 20 }}
          color="primary"
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="large"
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}
